
import ownerSchemaLogger from '@wix/bi-logger-ec-sf';
import visitorSchemaLogger from '@wix/bi-logger-ec-sf';

const createBILogger = <TLogger>(
    schemaLogger: (webOrMobileLogger: any) => (userConfig?: any) => TLogger,
) => (factory: any) => (userConfig: any = {}) => {
  return schemaLogger(factory)(userConfig);
}

export const createOwnerBILogger = createBILogger(ownerSchemaLogger);
export const createVisitorBILogger = createBILogger(visitorSchemaLogger);
